import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { IRxdbAdapterProvider } from './rxdb-adapter-provider.interface';

import { CapacitorSQLite, SQLiteConnection } from '@capacitor-community/sqlite';
import { Capacitor } from '@capacitor/core';

import { getRxStorageSQLite, getSQLiteBasicsCapacitor } from 'rxdb-premium/plugins/storage-sqlite';

import { getRxStorageIndexedDB } from 'rxdb-premium/plugins/storage-indexeddb';

@Injectable()
export class RxdbAdaptorProvider implements IRxdbAdapterProvider {
	public constructor(private platform: Platform) {}

	public getAdaptor(): any {
		if (this.platform.is('mobileweb') || this.platform.is('desktop')) {
			return getRxStorageIndexedDB({
				/**
				 * For better performance, queries run with a batched cursor.
				 * You can change the batchSize to optimize the query time
				 * for specific queries.
				 * You should only change this value when you are also doing performance measurements.
				 * [default=300]xwx
				 */
				batchSize: 300
			});
		} else {
			const sqlite = new SQLiteConnection(CapacitorSQLite);
			return getRxStorageSQLite({
				/**
				 * Different runtimes have different interfaces to SQLite.
				 * For example in node.js we have a callback API,
				 * while in capacitor sqlite we have Promises.
				 * So we need a helper object that is capable of doing the basic
				 * sqlite operations.
				 */
				sqliteBasics: getSQLiteBasicsCapacitor(sqlite, Capacitor)
			});
		}
	}
}
